import styled from "styled-components"

const ButtonStart = styled.button`
  width: 100%;
  padding: 8px 0;
  margin: 5px 0;
  text-align: center;
  border-radius: 5px;
  color: white;
  background: purple;
  font-weight: bold;
  font-size: 1.2rem;
`

export default ButtonStart